module.exports = __webpack_public_path__ + "static/media/jar-solid.c9c06b44.svg";